<template>
  <!--
  <div :id="id" :class="cssClass">
    <div class="card-header" v-html="titulo" v-if="titulo"></div>
    <div class="card-body" v-html="body"></div>
    <div class="card-footer" v-html="foot" v-if="foot"></div>
  </div>
  -->
  <v-expansion-panels :inset="true" :focusable="true">
    <v-expansion-panel color="primary">
      <v-expansion-panel-header v-if="titulo">{{
        titulo
      }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <template>
          <div v-html="body"></div>
          <div v-html="foot" v-if="foot"></div>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "cuerpo",
  props: {
    id: {
      type: String
    },
    titulo: {
      type: String
    },
    cuerpo: {
      type: String
    },
    pie: {
      type: String
    },
    enlace: {
      type: String
    },
    clase: {
      type: String
    }
  },
  computed: {
    cssClass: function() {
      var c = "card text";
      if (typeof this.clase !== "undefined") {
        return c + " " + this.clase;
      } else return c;
    },
    body: function() {
      var slot = this.$slots.default;
      if (typeof slot !== "undefined") {
        return slot;
      } else if (typeof this.cuerpo !== "undefined") {
        return this.cuerpo;
      } else return null;
    },
    foot: function() {
      var slot = this.$slots.default;
      if (typeof slot !== "undefined") {
        return slot;
      } else if (typeof this.enlace !== "undefined") {
        slot =
          "<a href='" +
          this.enlace +
          "' target='_blank' title='Más información...' class='text-link'><i class='icon-square-up-right'></i><b>Más información</b></a>";
        return slot;
      } else return null;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>